import { render, staticRenderFns } from "./iconSvg.vue?vue&type=template&id=f4189628&"
import script from "./iconSvg.vue?vue&type=script&lang=js&"
export * from "./iconSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports